// comunicacoesSection/index.tsx
//
// A aba "Comunicações". O gatilho do alerta continua morando em Suprimentos →
// Alertas e Notificações; o que passa a viver aqui é o TEXTO (Templates), o
// CANAL (Canais) e a regra que amarra os dois ao evento (Automações).
//
// ATENÇÃO — as strings dos `case` têm que bater EXATAMENTE com
// `verticalOptions["Comunicações"]` do shell (configuration/index.tsx), hoje
// ["Canais", "Templates", "Automações", "Log de envio"]. Nada liga as duas
// listas em tempo de compilação: divergir num acento manda o usuário para o
// "Sessão não encontrada" de baixo.
//
// NENHUMA das quatro telas envia mensagem. Não existe botão de disparo, de
// teste nem de "enviar agora" — nem desabilitado.

import React from "react";
import Canais from "./Canais";
import Templates from "./Templates";
import Automacoes from "./Automacoes";
import LogDeEnvio from "./LogDeEnvio";

interface ComunicacoesSectionProps {
  selectedVerticalOption: string;
  decryptedInfoToken: any;
  // A implementação real é (objectType, payload?) e devolve Promise de
  // { ok, tom, texto } — ver configuration/index.tsx.
  handleSave: (objectType: any, payload?: any) => any;
  handleOpenModal: (type: string, object?: any) => void;
  // O shell passa o mesmo pacote para todas as sections; estas quatro não são
  // usadas por nenhuma tela de Comunicações, e ficam opcionais para que a aba
  // não quebre se o shell parar de mandá-las.
  isEditing?: boolean;
  formData?: any;
  handleInputChange?: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    field: string
  ) => void;
  updateState?: (newState: any) => void;
}

const ComunicacoesSection: React.FC<ComunicacoesSectionProps> = ({
  selectedVerticalOption,
  decryptedInfoToken,
  handleSave,
  handleOpenModal,
}) => {
  switch (selectedVerticalOption) {
    case "Canais":
      return (
        <Canais
          decryptedInfoToken={decryptedInfoToken}
          handleSave={handleSave}
        />
      );
    case "Templates":
      return (
        <Templates
          decryptedInfoToken={decryptedInfoToken}
          handleOpenModal={handleOpenModal}
        />
      );
    case "Automações":
      return (
        <Automacoes
          decryptedInfoToken={decryptedInfoToken}
          handleSave={handleSave}
        />
      );
    case "Log de envio":
      return <LogDeEnvio />;
    default:
      return (
        <div
          style={{
            padding: "var(--sp-40)",
            textAlign: "center",
            color: "#6c757d",
          }}
        >
          <div style={{ fontSize: "var(--fs-6xl)", marginBottom: "var(--sp-16)" }}>🔍</div>
          <div style={{ fontSize: "var(--fs-lg)", marginBottom: "var(--sp-8)" }}>
            Sessão não encontrada
          </div>
          <div style={{ fontSize: "var(--fs-md)" }}>{selectedVerticalOption}</div>
        </div>
      );
  }
};

export default ComunicacoesSection;
